import * as stylex from '@stylexjs/stylex'
import { type ComponentPropsWithRef, type ForwardedRef } from 'react'
import { useXStyles, type XStyles } from '../useXStyles/useXStyles'
import { type ObjectFit, type Display } from '../utils/makeExtendStyle/extendStyles'

const dynamicStyles = stylex.create({
  width: (width: string | number) => ({ width }),
  height: (height: string | number) => ({ height }),
  borderRadius: (borderRadius: string | number) => ({ borderRadius }),
  display: (display: Display) => ({ display }),
  objectFit: (objectFit: ObjectFit) => ({ objectFit }),
})

const _baseStyles = stylex.create({
  root: {
    overflow: 'hidden',
    display: 'flex',
  },
  img: {
    height: 'auto',
    width: '100%',
  },
})

export interface ImageBaseProps extends ComponentPropsWithRef<'img'> {
  rootStyle?: stylex.StyleXStyles
  xStyles?: Partial<XStyles<keyof typeof _baseStyles>>
  rootRef?: ForwardedRef<HTMLDivElement>
  imgRef?: ForwardedRef<HTMLImageElement>
  borderRadius?: string | number
  display?: Display
  objectFit?: ObjectFit
}

export const ImageBase = (props: ImageBaseProps) => {
  const { rootRef, imgRef, rootStyle, xStyles, alt, src, width, height, display, borderRadius, objectFit, ...rest } = props
  const baseStyles = useXStyles(_baseStyles, xStyles)
  return (
    <div
      ref={rootRef}
      {...stylex.props(
        baseStyles.root,
        !!width && dynamicStyles.width(width),
        !!height && dynamicStyles.height(height),
        !!borderRadius && dynamicStyles.borderRadius(borderRadius),
        display !== undefined && dynamicStyles.display(display),
        rootStyle,
      )}
    >
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        {...stylex.props(baseStyles.img, objectFit && dynamicStyles.objectFit(objectFit))}
        {...rest}
      />
    </div>
  )
}
